

function set_collection_items(){

  fetch("/cart.js", {
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then((response) => response.json())
    .then((cart) => {
      try{
      updateCartProgress(cart)
      updateCartBubbles(cart);
      }
      catch(error){
        console.log(error)
      }
      var single = getSingleBundle()
      cart.items.forEach((item) => {
        const itemQuantityInput = document.querySelector(
          `ul#main-collection-product-grid quantity-input[data-id='${item.variant_id}']`
        );
        var addons = getAddOnS();
        var variant_ids = addons.variant_ids;
        if (addons.key == cart.token && variant_ids && (variant_ids.includes(item.id) || variant_ids.includes((item.id).toString()))) {
          const addon = document.querySelector(
            `ul#main-collection-product-grid addon-overlay input[data-id='${item.id}']`);
          if (addon) {
            addon.checked = true;
          }
        }
        if (single[item.id]) {
          for (var key in single[item.id]) { 
              if(single[item.id][key]*1>0){
                
                
                const a = document.querySelector(
                  `ul#main-collection-product-grid addon-overlay input[data-id='${key}']`);
                
                if (a && a.dataset.single_bundle =="true") {
                  a.checked = true;
                  const  x = document.querySelector(
                    `ul#main-collection-product-grid quantity-input[data-id='${key}']`
                  );
                  if(x){
                    x.input.value = single[item.id][key];
                    x.handleMinusButton();
                  }
                }
              }
          }
        }
        if (!itemQuantityInput) return;
        itemQuantityInput.input.value = item.quantity;
        itemQuantityInput.handleMinusButton();
      });
  
  
    });

}

set_collection_items()
function getAddOnS() {
  try {
    if (localStorage.getItem('addons')) {
      return JSON.parse(localStorage.getItem('addons'))
    }
  }
  catch (error) {

  }
  return { 'key': '', "variant_ids": [] }
}

function getSingleBundle() {
  try {
    if (localStorage.getItem('single_bundle')) {
      return JSON.parse(localStorage.getItem('single_bundle'))
    }
  }
  catch (error) {

  }
  return {}

}